module.exports = __webpack_public_path__ + "static/sui-table-pagination-b55983f52be2875bf47540ec98b2e176.png";